var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FounderSubHeader'),(_vm.page)?_c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"page-width",domProps:{"innerHTML":_vm._s(_vm.page.content.rendered)}})]):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }